import React from 'react';
import LoadingSpinner from '../../common/LoadingSpinner';
import AddressDropdown from '../../address/AddressDropdown';

const ReturnShippingAddresses = ({
  selectedCustomerAddress,
  handleCustomerAddressChange,
  selectedMerchantAddress,
  addressesLoading,
  returnDetails = {}
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-medium mb-4">Return Shipping Addresses</h3>
      
      {/* From address (customer) */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Ship From (Your Address)
        </label>
        {addressesLoading ? (
          <LoadingSpinner size="sm" />
        ) : (
          <AddressDropdown 
            value={selectedCustomerAddress?.id || returnDetails?.returnAddress?.id || ''}
            onChange={handleCustomerAddressChange}
            name="customerAddress"
            label=""
            fluid={true}
            placeholder="Select your address"
            showAddNew={true}
            required={true}
          />
        )}
      </div>
      
      {/* To address (merchant) */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Ship To (Merchant Address)
        </label>
        {!selectedMerchantAddress ? (
          <div className="py-2 px-3 bg-yellow-50 border border-yellow-200 rounded">
            <LoadingSpinner size="sm" className="mr-2" />
            <span className="text-sm text-yellow-700">Loading merchant address...</span>
          </div>
        ) : (
          <div className="p-3 border border-gray-300 rounded bg-gray-50">
            <p className="font-medium">{selectedMerchantAddress.name || 'Merchant'}</p>
            <p>{selectedMerchantAddress.street}</p>
            <p>{selectedMerchantAddress.city}, {selectedMerchantAddress.state} {selectedMerchantAddress.postalCode}</p>
            <p>{selectedMerchantAddress.country}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReturnShippingAddresses; 